import { render, staticRenderFns } from "./userAreaAuthModal.vue?vue&type=template&id=196eda4c&scoped=true"
import script from "./userAreaAuthModal.vue?vue&type=script&lang=js"
export * from "./userAreaAuthModal.vue?vue&type=script&lang=js"
import style0 from "./userAreaAuthModal.vue?vue&type=style&index=0&id=196eda4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196eda4c",
  null
  
)

export default component.exports